import { createSelector } from 'reselect'
import { namespace } from '.'
import { State } from './reducer'
import { getRfqWindow } from '../windows/selectors'
import { getOppositeDirection } from '../../components/DepthOfMarket/helpers'

type T = typeof namespace

type HasNsKey = {
  [key in T]: State
}
const getState = (state: HasNsKey): State => state[namespace]

export const getAllRfqQuotes = createSelector([getState], (state) =>
  Object.values(state.rfqActivity)
)

export const getActiveRfqQuoteRequestForSecurity = createSelector(
  [getState, getRfqWindow],
  (state, rfqWindowGetter) => (securityId: number) => {
    const quote = state.securityQuotes[securityId]
    if (quote) {
      const window = rfqWindowGetter(
        securityId,
        getOppositeDirection(quote.type)
      )
      if (window || quote.isLive) {
        return quote
      }
    }
  }
)

export const getRfqQuoteRequestForSecurity = createSelector(
  [getState],
  (state) => (securityId: number) => state.securityQuotes[securityId]
)

export const getRfqErrorForSecurity = createSelector(
  [getState],
  (state) => (securityId: number) => state.securityErrors[securityId]
)
